import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  ownerRequestForOwner: [],
  ownerRequestForUser: []
}

const getters = {
  ownerRequestForUser: state => state.ownerRequestForUser,
  ownerRequestForOwner: state => state.ownerRequestForOwner
}

const mutations = {
  ownerRequestForUser: (state, ownerRequestForUser) => {
    state.ownerRequestForUser = ownerRequestForUser
  },
  removeOwnerRequestForUser: (state, ownerRequestForUser) => {
    state.ownerRequestForUser = state.ownerRequestForUser.filter(item => item.id !== ownerRequestForUser.id)
  },
  ownerRequestForOwner: (state, ownerRequestForOwner) => {
    state.ownerRequestForOwner = ownerRequestForOwner
  },
  removeOwnerRequestForOwner: (state, requestId) => {
    state.ownerRequestForOwner = state.ownerRequestForOwner.filter(item => item.id !== requestId)
  }
}

const actions = {
  async addOwnerRequest ({ commit }, payload) {
    const communityId = payload.communityId
    const userId = payload.userId
    let response = await axios.post(`${config.getRootApi()}/ownerRequest/${communityId}/user/${userId}`, null)
    commit('ownerRequestForOwner', response.data)
  },
  resetownerRequestForUser ({ commit }) {
    commit('ownerRequestForUser', [])
  },
  resetownerRequestForOwner ({ commit }) {
    commit('ownerRequestForOwner', [])
  },
  async fetchUserOwnerRequests ({ commit }) {
    let response = await axios.get(`${config.getRootApi()}/ownerRequest/user`)
    commit('ownerRequestForUser', response.data)
  },
  async fetchOwnerOwnerRequests ({ commit }) {
    let response = await axios.get(`${config.getRootApi()}/ownerRequest/owner`)
    commit('ownerRequestForOwner', response.data)
  },
  async approveOwnerRequest ({ commit, dispatch }, ownerRequest) {
    axios.put(`${config.getRootApi()}/ownerRequest/approve`, ownerRequest)
      .then(response => commit('removeOwnerRequestForUser', response.data))
      .then(() => {
        dispatch('fetchCommunityDetails', ownerRequest.idCommunity)
      })
      .catch(error => console.error(error))
  },
  async declineOwnerRequest ({ commit }, ownerRequest) {
    axios.put(`${config.getRootApi()}/ownerRequest/decline`, ownerRequest)
      .then(response => commit('removeOwnerRequestForUser', response.data))
      .catch(error => console.error(error))
  },
  async cancelOwnerRequest ({ commit, dispatch }, ownerRequest) {
    axios.post(`${config.getRootApi()}/ownerRequest/cancel`, { requestId: ownerRequest.id, notificationUserId: ownerRequest.idUser, communityId: ownerRequest.idCommunity })
      .then(response => {
        commit('removeOwnerRequestForOwner', response.data.requestId)
        dispatch('deleteNotification', response.data.notificationId)
      })
      .catch(error => console.error(error))
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
